import React from 'react';
import { AlertCircleIcon, AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
// Sample data for residents at risk of falls
const residents = [{
  id: 1,
  name: 'Eleanor Johnson',
  age: 83,
  photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '203',
  fallsCount: 4,
  riskLevel: 'high',
  lastIncident: '2023-06-15',
  medications: ['Lisinopril', 'Furosemide', 'Sertraline'],
  mobility: 'Walker-dependent'
}, {
  id: 2,
  name: 'Robert Thompson',
  age: 78,
  photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '115',
  fallsCount: 3,
  riskLevel: 'high',
  lastIncident: '2023-07-02',
  medications: ['Amlodipine', 'Metoprolol', 'Simvastatin'],
  mobility: 'Cane-assisted'
}, {
  id: 3,
  name: 'Margaret Wilson',
  age: 86,
  photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '327',
  fallsCount: 3,
  riskLevel: 'high',
  lastIncident: '2023-05-28',
  medications: ['Donepezil', 'Memantine', 'Gabapentin'],
  mobility: 'Walker-dependent'
}, {
  id: 4,
  name: 'James Davis',
  age: 75,
  photo: 'https://images.unsplash.com/photo-1556474835-b0f3ac40d4d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '142',
  fallsCount: 2,
  riskLevel: 'medium',
  lastIncident: '2023-07-18',
  medications: ['Metformin', 'Glipizide', 'Losartan'],
  mobility: 'Independent with limitations'
}, {
  id: 5,
  name: 'Patricia Moore',
  age: 81,
  photo: 'https://images.unsplash.com/photo-1498757581981-8ddb3c0b9b07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '219',
  fallsCount: 2,
  riskLevel: 'medium',
  lastIncident: '2023-06-30',
  medications: ['Levothyroxine', 'Alendronate', 'Citalopram'],
  mobility: 'Walker-dependent'
}, {
  id: 6,
  name: 'Charles Miller',
  age: 79,
  photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '156',
  fallsCount: 1,
  riskLevel: 'low',
  lastIncident: '2023-08-05',
  medications: ['Atorvastatin', 'Lisinopril'],
  mobility: 'Independent'
}, {
  id: 7,
  name: 'Barbara Taylor',
  age: 84,
  photo: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '231',
  fallsCount: 1,
  riskLevel: 'low',
  lastIncident: '2023-07-12',
  medications: ['Metoprolol', 'Furosemide', 'Warfarin'],
  mobility: 'Cane-assisted'
}, {
  id: 8,
  name: 'Thomas White',
  age: 77,
  photo: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80',
  roomNumber: '118',
  fallsCount: 1,
  riskLevel: 'low',
  lastIncident: '2023-08-01',
  medications: ['Omeprazole', 'Tramadol'],
  mobility: 'Walker-dependent'
}];
export const ResidentRiskTable: React.FC = () => {
  const getRiskIcon = (riskLevel: string) => {
    switch (riskLevel) {
      case 'high':
        return <AlertCircleIcon className="h-5 w-5 text-red-500" data-id="element-141" />;
      case 'medium':
        return <AlertTriangleIcon className="h-5 w-5 text-orange-500" data-id="element-142" />;
      case 'low':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-143" />;
      default:
        return null;
    }
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <div className="overflow-x-auto" data-id="element-144">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-145">
        <thead className="bg-gray-50" data-id="element-146">
          <tr data-id="element-147">
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-148">
              Resident
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-149">
              Room
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-150">
              Falls (3 Months)
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-151">
              Risk Level
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-152">
              Last Incident
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-153">
              Mobility Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-154">
          {residents.map(resident => <tr key={resident.id} className="hover:bg-gray-50" data-id="element-155">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-156">
                <div className="flex items-center" data-id="element-157">
                  <div className="flex-shrink-0 h-10 w-10" data-id="element-158">
                    <img className="h-10 w-10 rounded-full object-cover" src={resident.photo} alt={resident.name} data-id="element-159" />
                  </div>
                  <div className="ml-4" data-id="element-160">
                    <div className="text-sm font-medium text-gray-900" data-id="element-161">
                      {resident.name}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-162">
                      {resident.age} years
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-163">
                {resident.roomNumber}
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-164">
                <div className="text-sm font-medium text-gray-900" data-id="element-165">
                  {resident.fallsCount}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-166">
                <div className="flex items-center" data-id="element-167">
                  {getRiskIcon(resident.riskLevel)}
                  <span className="ml-1 text-sm text-gray-700 capitalize" data-id="element-168">
                    {resident.riskLevel}
                  </span>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-169">
                {formatDate(resident.lastIncident)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-170">
                {resident.mobility}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};